import { doRequest } from '../../api/index';
import store from '../index';

const state = {
  sliderImages: [],
  allSliderImages: [],
};

const getters = {
  sliderImages(s) {
    return s.allSliderImages;
  },
  activeSliderImages(s) {
    return s.sliderImages;
  },
};

const actions = {
  loadActiveSliderImages({ commit }, args) {
    return doRequest('sliderImages.active', args)
      .then((data) => {
        commit('setActiveSliderImages', data);
      });
  },
  loadSliderImages({ commit }, args) {
    return doRequest('sliderImages.list', args)
      .then((data) => {
        commit('setSliderImages', data);
      });
  },
  deleteImage({ commit }, args) {
    return doRequest('sliderImages.delete', args).then(() => {
      return store.dispatch('loadSliderImages');
    });
  },
  editImage({ commit }, args) {
    return doRequest('sliderImages.update', args);
  },
  createImage({ commit }, args) {
    return doRequest('sliderImages.create', args);
  }
};

const mutations = {
  setSliderImages(s, data) {
    s.allSliderImages = data;
  },
  setActiveSliderImages(s, data) {
    s.sliderImages = data;
  }
};


export default {
  state,
  getters,
  actions,
  mutations,
};
